module.exports = __webpack_public_path__ + "img/rss-source-in-ui.2832e34f.png";